import React, { memo, SVGProps } from 'react';

interface IProps extends SVGProps<SVGSVGElement> {
	className?: string;
}

const ClockIcon: React.FC<IProps> = (props) => {
	return (
		<svg
			width="31"
			height="30"
			viewBox="0 0 31 30"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				opacity="0.4"
				d="M15.5 27.5C22.4036 27.5 28 21.9036 28 15C28 8.09644 22.4036 2.5 15.5 2.5C8.59644 2.5 3 8.09644 3 15C3 21.9036 8.59644 27.5 15.5 27.5Z"
				fill="white"
			/>
			<path
				d="M20.1375 19.9127C19.975 19.9127 19.8125 19.8752 19.6625 19.7752L15.7875 17.4627C14.825 16.8877 14.1125 15.6252 14.1125 14.5127V9.3877C14.1125 8.8752 14.5375 8.4502 15.05 8.4502C15.5625 8.4502 15.9875 8.8752 15.9875 9.3877V14.5127C15.9875 14.9627 16.3625 15.6252 16.75 15.8502L20.625 18.1627C21.075 18.4252 21.2125 19.0002 20.95 19.4502C20.7625 19.7502 20.45 19.9127 20.1375 19.9127Z"
				fill="white"
			/>
		</svg>
	);
};

export default memo(ClockIcon);
